export default __webpack_public_path__ + "static/media/avatar_34.8263d726.png";